.container {
  padding: var(--mirai-ui-space-XS);
  overflow-y: auto;
}

.checkout {
  height: calc(var(--mirai-ui-space-XXL) * 11.75);
  width: 100%;
}

@media only screen and (max-height: 850px) {
  .checkout {
    height: calc(var(--mirai-ui-space-XXL) * 9.5);
  }
}
